// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <path
        d="M6.06348 19.2395H9.76348V13.3645H14.3635V19.2395H18.0635V10.2395L12.0635 5.68945L6.06348 10.2395V19.2395ZM5.06348 20.2395V9.73945L12.0635 4.43945L19.0635 9.73945V20.2395H13.3635V14.3645H10.7635V20.2395H5.06348Z"
        fill="#323433"
      />
    </svg>
  );
}
